import { ACTIONS_MANUFACTURER } from '../_constants/manufacturer.constants';

const initialState = {
  byId: {},
};

export function manufacturerReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_MANUFACTURER.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MANUFACTURER.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MANUFACTURER.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default manufacturerReducer;
